import { ComboBox, DefaultButton, Dialog, DialogFooter, DialogType, IComboBoxOption, MessageBar, MessageBarType, PrimaryButton, ProgressIndicator, Stack, TextField } from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventApi } from '../../../../../Services/API/Event/IEventApi';
import { IEventSchedulesApi } from '../../../../../Services/API/EventSchedules/IEventSchedulesApi';
import * as Services from '../../../../../Services/Services';


interface IAddTeachersToLessonProps {
    isOpened: boolean;
    onDismiss: () => void;
    refresh: () => void;
    eventId: number;
    lessonId: number;
}

const dialogContentProps = {
    type: DialogType.normal,
    title: 'Přidání lektora na lekci',
    closeButtonAriaLabel: 'Close',
    subText: '',
};

const dialogStyles = { main: { maxWidth: 450 } };


export const AddTeachersToLesson: React.FunctionComponent<IAddTeachersToLessonProps> = (props) => {
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();
    const [teachersOptions, setTeacherOptions] = React.useState<IComboBoxOption[]>([]);
    const [lessons, setLessons] = React.useState<string>("1");
    const [teacherId, setTeacherId] = React.useState<string>();

    React.useEffect(() => {
        loadTeachers()
    }, [])

    const labelId: string = useId('dialogLabel');
    const subTextId: string = useId('subTextLabel');
    const modalProps = {
        titleAriaId: labelId,
        subtitleAriaId: subTextId,
        isBlocking: false,
        styles: dialogStyles,
    }

    const loadTeachers = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const schedulesApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await schedulesApi.getEventTeachers(props.eventId);
        if (result.isSuccess && result.data) {
            const to = result.data.sort((a, b) => (a.lastname > b.lastname) ? 1 : ((b.lastname> a.lastname) ? -1 : 0)).map(item => {
                const o: IComboBoxOption = {
                    key: item.userId,
                    text: item.firstname + " " + item.lastname
                }
                return o;
            })
            setTeacherOptions(to);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }
         
    


    const saveTeacher = async () => {
        if (teacherId) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const schedulesApi = Services.ServicesProvider.GetService<IEventSchedulesApi>(Services.EventSchedulesApi);
            const result = await schedulesApi.addTeacherToLesson({
                eventId: props.eventId,
                id: props.lessonId,
                lessons: Number.parseFloat(lessons),
                teacherId: teacherId
            });
            if (result.isSuccess && result.data) {
                props.refresh();
                props.onDismiss();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
    }
    
    return (<><Dialog
        hidden={!props.isOpened}
        onDismiss={props.onDismiss}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}>
        <Stack tokens={{ childrenGap: 10 }}>
            <ComboBox label="Vyberte lektora" selectedKey={teacherId} options={teachersOptions} onChange={(e, o, i, v) => setTeacherId(o?.key as string)} />
            <TextField label="Počet lekcí" value={lessons.toString()} onChange={(e, v) => setLessons(v?v:"1")} />
        </Stack>
        <Stack styles={{ root: { height: 10 } }}>
            {isLoading ? <ProgressIndicator /> : null}
        </Stack>
        {statusMessage ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
        <DialogFooter>
            <PrimaryButton onClick={saveTeacher} text="Přidat" />
            <DefaultButton onClick={props.onDismiss} text="Zrušit" />
        </DialogFooter>
    </Dialog></>)
}